// Angular Files
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sentencecase',
    standalone: false
})
export class SentenceCasePipe implements PipeTransform {
    // Normalize backend status strings for display.
    //  - Cancelled → Canceled: spelling inconsistency between backend strings.
    //  - ProcessingFailed → Failed: "Processing Failed" is too long for the
    //    status-badge column; the customer-friendly failure message renders
    //    below the badge so the distinction (processing vs posting) lives there.
    private static readonly _OVERRIDES: Record<string, string> = {
        Cancelled: 'Canceled',
        ProcessingFailed: 'Failed'
    };

    transform(value: string): string {
        return SentenceCasePipe._OVERRIDES[value]
            ?? value?.replace(/([A-Z])/g, ' $1').trim();
    }
}
